const CustomIconCurve = ({ className = '' }: { className?: string }) => (
  <svg
    className={className}
    width="1440"
    height="185"
    viewBox="0 0 1440 185"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1440 0H0V184.833C155.376 133.677 419.856 100 720 100C1020.14 100 1284.62 133.677 1440 184.833V0Z"
      fill="#F2F0EC"
    />
  </svg>
)

export default CustomIconCurve
